
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 4v2h9.563L13.5 17.063l-4-4L8.094 14.5l4 4L4 26.594 5.406 28l8.094-8.094 4.125 4.125 1.406-1.406-4.125-4.125L26 7.437V17h2V4z"}})])
          )
        }
      }
    